import React from 'react';
import algoFoxLogo from '../assets/images/algofox-logo.png';

interface FoxMarkProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-16 w-16',
};

const FoxMark: React.FC<FoxMarkProps> = ({ size = 'md', className = '' }) => {
  return (
    <span className={`inline-flex items-center justify-center overflow-hidden rounded-full bg-[#fff8ef] ${sizeClasses[size]} ${className}`}>
      <img
        src={algoFoxLogo}
        alt="AlgoFox mark"
        className="h-full w-full translate-x-[7%] translate-y-[6%] object-contain"
      />
    </span>
  );
};

export default FoxMark;
